import { Container } from '@components/ui'
import WYSIWYG from '@components/ui/WYSIWYG'
import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'
interface Props {
  slice: any
}

const HomepageInspirationBanner = ({ slice }: Props) => {
  const sliceItems = slice?.items
  const inspirationText = slice?.primary?.InspirationText
  return (
    <section>
      <div className="w-full bg-brand-grey">
        <Container>
          <div className="grid grid-cols-3 gap-1 md:gap-2">
            {sliceItems.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  className="flex grow justify-start first:col-span-2 first:row-span-2 first:md:col-auto first:md:row-auto"
                >
                  {item?.InspirationImage?.url && (
                    <Image
                      src={item.InspirationImage.url}
                      alt={
                        item?.InspirationImage?.alt ||
                        config.openGraph.images[0].alt
                      }
                      width={item?.InspirationImage?.dimensions?.width}
                      height={item?.InspirationImage?.dimensions?.height}
                    />
                  )}
                </div>
              )
            })}
          </div>
          <div className="flex justify-center pt-8 pb-16 text-center md:pt-16 md:pb-20">
            {inspirationText && (
              <div className="heading-mobile-3 md:heading-3 w-full text-brand-dark-grey md:w-160">
                <WYSIWYG content={inspirationText} />
              </div>
            )}
          </div>
        </Container>
      </div>
    </section>
  )
}

export default HomepageInspirationBanner
